import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Contatto } from '../../shared/interface';

import mapboxgl from 'mapbox-gl';
import { environment } from '../../../environments/environment.development';

@Component({
  selector: 'app-contatti',
  templateUrl: './contatti.component.html',
  styleUrl: './contatti.component.css',
  encapsulation: ViewEncapsulation.None
})
export class ContattiComponent implements OnInit {

  constructor(private apiService: ApiService) { }

  contatti: Contatto[] = [];

  ngOnInit(): void {

    this.apiService.getContatti().subscribe({
      next: (data) => this.contatti = [...data],
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => { }
    });

    mapboxgl.accessToken = environment.mapboxgl.accessToken;
    const map = new mapboxgl.Map({
      container: 'map', // container ID
      style: 'mapbox://styles/mapbox/streets-v12', // style URL
      center: [7.679355194253247, 45.05235282378113], // starting position [lng, lat]
      zoom: 15, // starting zoom
    });
    
    const marker = document.createElement('div');

    marker.className = 'marker';
    const teatro = new mapboxgl.Marker(marker, {offset: [56/2, -56/2]})
      .setLngLat([7.679355194253247, 45.05235282378113])
      .addTo(map);
  }

}